var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms"},[_c('a',{staticClass:"iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed",attrs:{"href":"https://www.iubenda.com/terms-and-conditions/84994680","title":"Terms and Conditions"}},[_vm._v("Terms and Conditions")])])
}]

export { render, staticRenderFns }